import React from 'react';

const StorySection = ({ id }) => {
  return (
    <section id={id} className="story-section section-container">
      <div className="section-header">
        <h2 className="section-title">El momento que lo cambió todo</h2>
      </div>

      <div className="story-content">
        <p className="story-text emphasis">Todo comenzó con una conversación.</p>
        
        <div className="story-timeline">
          <p>Después de años de carrera juntos.</p>
          <p>Después de procesos exigentes.</p>
          <p>Después de verla levantar la Champions League.</p>
          <p>Después de verla convertirse en la mejor arquera del mundo.</p>
        </div>

        <div className="story-quote">
          <p className="quote-text">"A los arqueros no nos entienden de verdad."</p>
        </div>

        <p className="story-text">Y esa frase marcó un antes y un después.</p>
        
        <p className="story-text">
          Porque incluso en la élite, incluso ganando todo, el arquero sigue siendo 
          una posición incomprendida.
        </p>

        <p className="story-text highlight">Ahí nació The Keeper Lab.</p>
      </div>

      <div className="story-image">
        <img 
          src="https://customer-assets.emergentagent.com/job_keeper-elite/artifacts/fpiaizz1_IMG_9991.jpeg" 
          alt="Christiane Endler - Professional Goalkeeper"
          className="section-image"
        />
      </div>
    </section>
  );
};

export default StorySection;
